import { useDblIntl } from "@/pages/datalab/utils/utils";

import HistogramOne from '@/pages/datalab/assets/svg/workBench/histogram-img-one.svg';
import HistogramTwo from '@/pages/datalab/assets/svg/workBench/histogram-img-two.svg';
import TableOne from '@/pages/datalab/assets/svg/workBench/table-img-one.svg';
import lineOne from '@/pages/datalab/assets/svg/workBench/line-chart-one.svg';
import pieOne from '@/pages/datalab/assets/svg/workBench/pie-chart-one.svg';
import { ChartType } from '@dbl/core/chart';

export const useChartTypeList = () => {
  const { commonFormatMessage, formatMessage, isEn } = useDblIntl();
  const chartList = [
    {
      title: commonFormatMessage('table_title'),
      icon: 'sheet',
      list: [{ text: commonFormatMessage('table'), img: TableOne, type: ChartType.Table }],
    },
    {
      title: commonFormatMessage('bar_title'),
      icon: 'column-chart',
      list: [
        { text: commonFormatMessage('bar'), img: HistogramOne, type: ChartType.Bar },
        { text: commonFormatMessage('stack_bar'), img: HistogramTwo, type: ChartType.StackBar },
      ],
    },
    {
      title: commonFormatMessage('line_title'),
      icon: 'discount-chart',
      list: [{ text: commonFormatMessage('line'), img: lineOne, type: ChartType.Line }],
    },
    {
      title: commonFormatMessage('pie_title'),
      icon: 'pie-chart-icon',
      list: [{ text: commonFormatMessage('pie'), img: pieOne, type: ChartType.Pie }],
    },
  ];
  return chartList;
};
